import React from "react";
import Heading from "../Heading/Heading";
import LeftImage from "../../components/LeftSection/LeftImage";
import RightImage from "../RightSection/RightImage";
import section_image_5 from "../../assets/images/section_image_5.jpg";
import section_image_6 from "../../assets/images/section_image_6.jpg";
import section_image_7 from "../../assets/images/section_image_7.jpg";
import "./InHouse.css";
import Button from "../Button/Button";

export default function InHouse() {

  return (
    <div className="inhouse">
      <div className="container padding_top_bottom">
        <Heading MainHeader="OUR IN-HOUSE EXPERTISE" />
        <RightImage
          Subtitle="Finance"
          Paragraph="Financial experience and expertise. Smooth processing of all lines of deferred payments such as Letters of Credit, Standby Guarantees, Bid Bonds and Performance Bonds"
          btnLink=""
          btnText=""
          SideImage={section_image_5}
        />
        <LeftImage
          Subtitle="Logistic and Packing"
          Paragraph="Ensure correct packaging methods (according to world standards) are used to protect products. Direct control of shipping lines and road haulers using our in-house logistics department."
          btnLink=""
          btnText=""
          SideImage={section_image_6}
        />
        <RightImage
          Subtitle="Contract Management"
          Paragraph="Ensure that the project runs according to the contract parameters Monitoring deliveries to the customer"
          btnLink=""
          btnText=""
          SideImage={section_image_7}
        />
        <div className="btn_center">
          <Button btnLink="/inhouseexpertise" btnText="View All Expertise" />
        </div>
      </div>
    </div>
  );
}
